import {EPermissions, ScreenProp} from 'src/app/models'

type TKeys = 'WO_INCOMING' | 'WO_INCOMING_LIST' | 'WO_INCOMING_DETAIL' | 'WO_INCOMING_EDIT'

export const WoIncomingScreen: Record<TKeys, ScreenProp> = {
  WO_INCOMING: {
    PATH: '/work-order/incoming',
    TITLE: 'WO Diterima',
    TITLE_ALT: 'WO Diterima',
  },
  WO_INCOMING_LIST: {
    PATH: '/work-order/incoming/list',
    TITLE: 'WO Diterima',
    TITLE_ALT: 'Diterima',
    PERMISSION: [EPermissions.WORK_ORDER_INCOMING_READ],
  },
  WO_INCOMING_DETAIL: {
    PATH: '/work-order/incoming/detail/:id',
    TITLE: 'Detail Permintaan WO',
    TITLE_ALT: 'Detail Permintaan WO',
    PERMISSION: [EPermissions.WORK_ORDER_INCOMING_READ],
  },
  WO_INCOMING_EDIT: {
    PATH: '/work-order/incoming/edit/:id',
    TITLE: 'Edit WO',
    TITLE_ALT: 'Edit WO',
    PERMISSION: [EPermissions.WORK_ORDER_INCOMING_UPDATE],
  },
}
